module.exports = __webpack_public_path__ + "static/media/rin_active27097987aff5e9b7014facc44ef47d56.webp";